// @flow
import Component from './component';
import { connect } from 'react-redux';
import type { Map } from 'immutable';
import { curry, flowRight } from 'lodash/fp';
// These paths are relative because they cause problems with Jest mocking when aliased
import type { Features, Entitlements, ImmutableAs } from '../../types';
import { getConfig } from '../../state/config/selectors';
import { getConfig as getEntitlementsConfig } from '../../state/entitlements/selectors';
import { toJS } from '../../utils/immutable';

const pick = curry((keys, obj) =>
    keys.reduce(
        (agg, key) => ({
            ...agg,
            [key]: obj[key] || null
        }),
        {}
    )
);

export const toEntitlements: ImmutableAs<Entitlements> = flowRight(pick(['MimicMode']), toJS);

type Props = {
    children: () => React.Element<*>
};

const mapStateToProps = (
    state: Object,
    ownProps: Props
): {
    entitlementFlags: *,
    featureFlags: Object,
    isValidChildren: boolean
} => {
    const config: Map<*, *> = getConfig(state);
    const entitlementFlags = toEntitlements(getEntitlementsConfig(state));

    const isValidChildren = typeof ownProps.children === 'function';

    if (process.env.NODE_ENV !== 'production') {
        if (!isValidChildren) {
            // eslint-disable-next-line
            console.warn(
                'You must pass `children` as a function to <ConditionalFeature />. ' +
                    'Such that <ConditionalFeature>{() => <div>Hello World</div>}</ConditionalFeature>'
            );
        }
    }

    // $FlowFixMe
    const featureFlags: Features = config.toJS().features;

    return {
        featureFlags,
        entitlementFlags,
        isValidChildren
    };
};

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./src/core/components/conditional-feature/index.js